const related = {
  // ===== Shared =====
  'related.common.official': 'Visit the official site',
  'related.common.externalNote': 'This link opens an external site in a new window.',
  'related.common.backToHub': 'Back to related organizations',
  'related.common.backToTop': 'Back to top',
  'related.common.otherTitle': 'Other related organizations',
  'related.common.otherSubtitleEn': 'Other related organizations',

  // ===== Hub /related =====
  'related.hub.hero.home': 'Home',
  'related.hub.hero.about': 'About the Academy',
  'related.hub.hero.current': 'Related Organizations',
  'related.hub.hero.title': 'Related Organizations',
  'related.hub.hero.titleEn': 'RELATED ORGANIZATIONS',
  'related.hub.hero.lead':
    'Japan Butler Academy is operated by The All Japan Butler Association and works closely with several organizations and brands that support Japanese butler culture.',
  'related.hub.hero.imgAlt': 'A butler attending in an elegant residence',

  'related.hub.intro.label': 'OUR NETWORK',
  'related.hub.intro.title': 'The Association group behind butler culture',
  'related.hub.intro.subtitleEn': 'The organizations behind the academy',
  'related.hub.intro.para1':
    'The education at Japan Butler Academy does not stand alone. \n\nCentered on The All Japan Butler Association as its operating body, a brand that shares butler culture with society and a brand that delivers actual butler services work together, connecting learning and real-world practice into a single flow.',
  'related.hub.intro.para2':
    'This page introduces the related organizations closely tied to Japan Butler Academy: The All Japan Butler Association, Butler Bell, THE BUTLER, Family Romance Inc., and the Yuichi Ishii Official Site. \n\nFor each, we explain its role and its connection to the Academy, so you can see the wider picture of the butler profession.',

  'related.hub.cards.label': 'RELATED ORGANIZATIONS',
  'related.hub.cards.title': 'Five related organizations',
  'related.hub.cards.subtitleEn': 'Five related organizations',

  'related.hub.card.association.name': 'The Japan Butler Association',
  'related.hub.card.association.role': 'Training & certification',
  'related.hub.card.association.desc':
    'The body that trains butlers, issues Association-certified credentials, and delivers corporate programs. As the operating body of Japan Butler Academy, it works to raise the social value of the butler profession.',
  'related.hub.card.association.imgAlt': 'A butler in a morning coat standing to receive guests in a formal reception room',

  'related.hub.card.bell.name': 'Butler Bell',
  'related.hub.card.bell.role': 'Media brand',
  'related.hub.card.bell.desc':
    'The official brand of Yuichi Ishii, the Third Todori (head) of The All Japan Butler Association. Through the "Butler Bell" YouTube channel and more, it shares the true image of a butler and the spirit of hospitality.',
  'related.hub.card.bell.imgAlt': 'Portrait of a butler in formal attire',

  'related.hub.card.butler.name': 'THE BUTLER',
  'related.hub.card.butler.role': 'Gateway to butler service',
  'related.hub.card.butler.desc':
    'A butler service operated by The All Japan Butler Association. From the home to business and VVIP care, it is the gateway that supports daily life and hospitality comprehensively, and a place where Academy graduates put their skills to work.',
  'related.hub.card.butler.imgAlt': 'A butler serving in a luxury residence',

  'related.hub.card.fr.name': 'Family Romance Inc.',
  'related.hub.card.fr.role': 'The stand-in service company founded by the Todori',
  'related.hub.card.fr.desc':
    'A family stand-in service company led by Yuichi Ishii, the Third Todori (head) of The All Japan Butler Association, as its CEO. Since its founding in 2004, it has provided a wide range of stand-in services nationwide.',
  'related.hub.card.fr.imgAlt': 'The office floor of Family Romance Inc.',

  'related.hub.card.ishii.name': 'Yuichi Ishii Official Site',
  'related.hub.card.ishii.role': "The Todori's work as an actor and entrepreneur",
  'related.hub.card.ishii.desc':
    'The official site of Yuichi Ishii, the Third Todori (head) of The All Japan Butler Association. It covers his role in the film "Family Romance, LLC" and his Glass Award from a Harvard University lecture.',
  'related.hub.card.ishii.imgAlt': 'Portrait of Yuichi Ishii',

  'related.hub.card.viewInternal': 'Learn more',
  'related.hub.card.viewExternal': 'Official site',

  'related.hub.rel.label': 'RELATIONSHIP',
  'related.hub.rel.title': 'How the Academy and its related organizations connect',
  'related.hub.rel.subtitleEn': 'How we are connected',
  'related.hub.rel.body':
    'The All Japan Butler Association serves as the operating body, and its education division is Japan Butler Academy. \n\nThe official brand of the Association’s Third Todori (head) is Butler Bell, and the butler service the Association provides is THE BUTLER. Learning, communication, and practice are all connected under one Association.',

  'related.hub.cta.title': 'If you are interested in learning the butler craft',
  'related.hub.cta.body':
    'For questions about our courses, Association-certified credentials, or corporate programs, please feel free to contact us. Brochures are available free of charge.',
  'related.hub.cta.courses': 'View courses',
  'related.hub.cta.contact': 'Contact us',
  'related.hub.lastUpdated': 'Last updated: July 5, 2026',

  // ===== The Japan Butler Association /related/butler-association =====
  'related.assoc.hero.home': 'Home',
  'related.assoc.hero.parent': 'Related Organizations',
  'related.assoc.hero.current': 'The Japan Butler Association',
  'related.assoc.hero.title': 'The Japan Butler Association',
  'related.assoc.hero.titleEn': 'THE JAPAN BUTLER ASSOCIATION',
  'related.assoc.hero.lead':
    'A general incorporated association working to raise the social value of the butler profession through training, Association-certified credentials, and corporate programs.',
  'related.assoc.hero.imgAlt': 'A butler in a morning coat standing in a formal reception room',

  'related.assoc.about.label': 'ABOUT',
  'related.assoc.about.title': 'What is The All Japan Butler Association?',
  'related.assoc.about.subtitleEn': 'What is The All Japan Butler Association?',
  'related.assoc.about.para1':
    'The Japan Butler Association is a general incorporated association that trains, certifies, and delivers corporate programs for butlers, with the goal of raising the social value of the butler profession. \n\nJapan Butler Academy is the education division operated by the Association.',
  'related.assoc.about.para2':
    'The Association\u2019s work goes beyond training. By awarding Association-certified credentials to those who complete the required curriculum and pass a practical exam, it guarantees the quality of the butlers it trains. It also delivers corporate business-manner training based on butler hospitality skills, extending butler conduct into a wider range of professional settings.',
  'related.assoc.about.para3':
    'Positioning the butler profession not as a rare specialty confined to a narrow world, but as a professional field evaluated against clear standards \u2014 that is why the Association consistently carries out training, certification, and corporate programs together.',

  'related.assoc.points.label': 'OUR ROLE',
  'related.assoc.points.title': 'Four roles of the Association',
  'related.assoc.points.subtitleEn': 'What the Association does',
  'related.assoc.points.1.title': 'Training butlers',
  'related.assoc.points.1.desc':
    'Through Japan Butler Academy, it trains butlers with a structured curriculum from Essential through Master level.',
  'related.assoc.points.2.title': 'Issuing Association-certified credentials',
  'related.assoc.points.2.desc':
    'It awards Association-certified butler credentials to those who complete the curriculum and pass a practical exam, guaranteeing the quality of the butlers it trains.',
  'related.assoc.points.3.title': 'Delivering corporate programs',
  'related.assoc.points.3.desc':
    'It provides corporate business-manner training based on butler hospitality skills, on-site or at the Academy, tailored to each company.',
  'related.assoc.points.4.title': 'Raising the social value of the profession',
  'related.assoc.points.4.desc':
    'By consistently carrying out training, certification, and corporate programs, it clarifies the standards of the butler profession and works to raise its social standing.',

  'related.assoc.role.label': 'RELATIONSHIP WITH TJBA',
  'related.assoc.role.title': 'Connection with the Academy',
  'related.assoc.role.subtitleEn': 'Connection with the academy',
  'related.assoc.role.para1':
    'Japan Butler Academy is the education division operated by The All Japan Butler Association. The Association\u2019s philosophy of raising the social value of the butler profession through training, certification, and corporate programs underlies the Academy\u2019s approach to training butlers.',
  'related.assoc.role.para2':
    'Yuichi Ishii, known as Butler Bell, serves as the Association\u2019s Third Todori (head). Japan Butler Academy as the place of learning, Butler Bell as the voice that communicates, and THE BUTLER as the butler service \u2014 all of these are connected under The All Japan Butler Association.',

  'related.assoc.service.label': 'FOR THOSE SEEKING BUTLER SERVICE',
  'related.assoc.service.title': 'If you are looking to hire a butler',
  'related.assoc.service.body1':
    'THE BUTLER is the butler service operated by the Association. From the home to business and VVIP care, it supports daily life and hospitality comprehensively.',
  'related.assoc.service.body2':
    'For details on the services and how to request them, please visit the THE BUTLER official site.',
  'related.assoc.service.cta': 'Learn more about THE BUTLER',
  'related.assoc.service.url': 'thebutler.jp',

  'related.assoc.official.title': 'The Japan Butler Association official site',
  'related.assoc.official.body':
    'For more on the Association\u2019s activities and organizational details, please visit the official site.',
  'related.assoc.official.url': 'www.butler-association.jp',
  'related.assoc.lastUpdated': 'Last updated: July 5, 2026',

  // ===== Butler Bell /related/butler-bell =====
  'related.bell.hero.home': 'Home',
  'related.bell.hero.parent': 'Related Organizations',
  'related.bell.hero.current': 'Butler Bell',
  'related.bell.hero.title': 'Butler Bell',
  'related.bell.hero.titleEn': 'BUTLER BELL',
  'related.bell.hero.lead':
    'The official media brand of Yuichi Ishii, the Third Todori (head) of The All Japan Butler Association.',
  'related.bell.hero.imgAlt': 'Portrait of a butler in formal attire',

  'related.bell.about.label': 'ABOUT',
  'related.bell.about.title': 'What is Butler Bell?',
  'related.bell.about.subtitleEn': 'Who is Butler Bell?',
  'related.bell.about.para1':
    'Butler Bell is the official brand of Yuichi Ishii, who serves as the Third Todori (head) of The All Japan Butler Association. \n\nDrawing on years of experience serving clients in Japan and abroad as a butler, he continues to share the true image of a butler and the uniquely Japanese spirit of hospitality with society at large.',
  'related.bell.about.para2':
    'Through the "Butler Bell" YouTube channel and other media, the brand carefully introduces not only the polished front of butler service but also the discipline, conduct, and mindset behind it. \n\nIt offers practical, in-depth content for those who want to learn manners and hospitality, or who are interested in the butler profession.',
  'related.bell.about.para3':
    'Butler Bell is also an effort to retell butler culture in a way that fits modern life. While respecting tradition, it connects the appeal of butlers to the next generation through contemporary media such as video and social networks.',

  'related.bell.points.label': 'HIGHLIGHTS',
  'related.bell.points.title': 'What Butler Bell does',
  'related.bell.points.subtitleEn': 'What Butler Bell does',
  'related.bell.points.1.title': 'Sharing butler culture',
  'related.bell.points.1.desc':
    'Through the "Butler Bell" YouTube channel and more, it shares a butler’s daily life, conduct, and spirit of hospitality.',
  'related.bell.points.2.title': 'Introducing manners and refinement',
  'related.bell.points.2.desc':
    'It explains, in an approachable way, butler refinement such as table manners and poise that can also be used in everyday life.',
  'related.bell.points.3.title': 'Modernizing butler culture',
  'related.bell.points.3.desc':
    'It continues to pass the traditional way of the butler on to the next generation through contemporary media.',

  'related.bell.role.label': 'RELATIONSHIP WITH TJBA',
  'related.bell.role.title': 'Connection with the Academy',
  'related.bell.role.subtitleEn': 'Connection with the academy',
  'related.bell.role.para1':
    'Yuichi Ishii, known as Butler Bell, is the Third Todori (head) of The All Japan Butler Association, the operating body of Japan Butler Academy. \n\nUnder the Association’s philosophy of "training butlers to world standards," his view of the butler craft lives on in the Academy’s teaching approach.',
  'related.bell.role.para2':
    'The idea of "genuine hospitality" that Butler Bell communicates is deeply connected to the conduct and mindset taught at Japan Butler Academy. \n\nFor those who first encounter the butler world through videos or articles and then wish to study it systematically, the Academy is the place that welcomes them.',

  'related.bell.official.title': 'Butler Bell official site',
  'related.bell.official.body':
    'For details on Butler Bell’s activities and content, please visit the official site.',
  'related.bell.official.url': 'butlerbell.jp',
  'related.bell.lastUpdated': 'Last updated: July 3, 2026',

  // ===== THE BUTLER /related/the-butler =====
  'related.butler.hero.home': 'Home',
  'related.butler.hero.parent': 'Related Organizations',
  'related.butler.hero.current': 'THE BUTLER',
  'related.butler.hero.title': 'THE BUTLER (Butler Service)',
  'related.butler.hero.titleEn': 'THE BUTLER',
  'related.butler.hero.lead':
    'A hospitality service by butlers, operated by The All Japan Butler Association. Consultations and requests are handled through the official THE BUTLER site.',
  'related.butler.hero.imgAlt': 'A butler serving in a luxury residence',

  'related.butler.about.label': 'ABOUT',
  'related.butler.about.title': 'What is THE BUTLER?',
  'related.butler.about.subtitleEn': 'What is THE BUTLER?',
  'related.butler.about.para1':
    'THE BUTLER is a butler service operated by The All Japan Butler Association, which is also the operating body of Japan Butler Academy. \n\nIt offers fully bespoke hospitality that layers the uniquely Japanese sense of courtesy over the discipline and grace of the British butler tradition.',
  'related.butler.about.para2':
    'Rather than simply substituting for household chores, it values creating the very environment in which clients can focus on the work, family, and rest that truly matter to them. \n\nSensing needs before the master puts them into words and attending quietly at their side—this anticipatory service is the essence of THE BUTLER.',

  'related.butler.services.label': 'SERVICES',
  'related.butler.services.title': 'Main services',
  'related.butler.services.subtitleEn': 'What the butlers provide',
  'related.butler.services.1.title': 'Housekeeping',
  'related.butler.services.1.desc':
    'Quietly maintaining the foundations of daily life—home management, cooking, laundry, shopping, and accompanying and watching over children.',
  'related.butler.services.2.title': 'Business support',
  'related.butler.services.2.desc':
    'Supporting busy days through schedule management, document preparation, meeting arrangements, and chauffeuring.',
  'related.butler.services.3.title': 'Events and reception',
  'related.butler.services.3.desc':
    'Handling hospitality for special occasions, including greeting and seeing off guests, serving, and setting the scene.',
  'related.butler.services.4.title': 'Butler concierge',
  'related.butler.services.4.desc':
    'A bespoke service prepared for VVIP and high-net-worth clients.',

  'related.butler.role.label': 'RELATIONSHIP WITH TJBA',
  'related.butler.role.title': 'Connection with the Academy',
  'related.butler.role.subtitleEn': 'Connection with the academy',
  'related.butler.role.para1':
    'Both THE BUTLER and Japan Butler Academy are based on The All Japan Butler Association. THE BUTLER is one of the settings where butlers trained by the Academy deliver service with grace and poise.',
  'related.butler.role.para2':
    'The fact that learning and practice are connected under the same Association means the Academy’s education is not merely theoretical but designed with the actual service field in view. \n\nFor those considering the butler profession as a future path, it is a relationship that lets them picture what lies ahead in concrete terms.',

  'related.butler.official.title': 'THE BUTLER official site (consultations & requests)',
  'related.butler.official.body':
    'Consultations and requests for butler service are handled through the THE BUTLER official site, where plans and pricing are also detailed.',
  'related.butler.official.url': 'thebutler.jp',
  'related.butler.lastUpdated': 'Last updated: July 5, 2026',

  // ===== Family Romance /related/family-romance =====
  'related.fr.hero.home': 'Home',
  'related.fr.hero.parent': 'Related Organizations',
  'related.fr.hero.current': 'Family Romance',
  'related.fr.hero.title': 'Family Romance Inc.',
  'related.fr.hero.titleEn': 'FAMILY ROMANCE',
  'related.fr.hero.lead':
    'A family stand-in service company led by Yuichi Ishii, the Third Todori (head) of The All Japan Butler Association, as its CEO.',
  'related.fr.hero.imgAlt': 'The office floor of Family Romance Inc.',

  'related.fr.about.label': 'ABOUT',
  'related.fr.about.title': 'What is Family Romance Inc.?',
  'related.fr.about.subtitleEn': 'What is Family Romance Inc.?',
  'related.fr.about.para1':
    "Family Romance Inc. was founded in 2004 by Yuichi Ishii. At 24, after helping a single-mother friend with a kindergarten entrance exam, he began a stand-in service and gave shape to \"family stand-ins,\" a concept that did not yet exist in Japan.",
  'related.fr.about.para1Link': 'family-romance.com',
  'related.fr.about.para2':
    'For more than 20 years since, it has provided a wide range of stand-in services nationwide, from family, partner, and friend stand-ins to wedding proxy attendance and apology proxy services. \n\nWith more than 5,000 registered staff across Japan, it is equipped to respond to each client’s individual circumstances.',
  'related.fr.about.para2Link': 'See the full range of services',

  'related.fr.points.label': 'HIGHLIGHTS',
  'related.fr.points.title': 'Four highlights of Family Romance',
  'related.fr.points.subtitleEn': 'What Family Romance does',
  'related.fr.points.1.title': 'Pioneer of family stand-in services',
  'related.fr.points.1.desc':
    'Since its founding in 2004, it has given shape to the concept of "stand-in services," which did not exist in Japan, spanning family, partner, and friend stand-ins through to wedding proxy attendance.',
  'related.fr.points.2.title': 'A staff network of over 5,000',
  'related.fr.points.2.desc':
    'With more than 5,000 registered staff nationwide, it is equipped to respond to each client’s individual circumstances.',
  'related.fr.points.3.title': 'An internationally screened film appearance',
  'related.fr.points.3.desc':
    'CEO Yuichi Ishii starred as himself in Werner Herzog’s film "Family Romance, LLC," which screened in the Directors’ Fortnight section of the 72nd Cannes Film Festival.',
  'related.fr.points.3.link': 'See the film details',
  'related.fr.points.4.title': 'Thorough information management',
  'related.fr.points.4.desc':
    'All staff sign NDAs to prevent leaks of information learned on assignment, resulting in a track record of zero information leaks over more than 20 years.',

  'related.fr.role.label': 'RELATIONSHIP WITH TJBA',
  'related.fr.role.title': 'Connection with the Academy',
  'related.fr.role.subtitleEn': 'Connection with the academy',
  'related.fr.role.para1':
    'Yuichi Ishii, the Third Todori (head) of The All Japan Butler Association, is also the founder and CEO of Family Romance Inc. \n\nTraining butlers as a professional discipline and running a family stand-in business are different in form, but both rest on Ishii’s consistent belief in supporting the connections between people.',
  'related.fr.role.para2':
    'The butler’s mindset that Japan Butler Academy values — sensing what the other person needs and quietly supporting them — resonates with the client-centered approach Family Romance has cultivated over more than 20 years.',
  'related.fr.role.para2Link': 'Visit the Family Romance official site',

  'related.fr.official.title': 'Family Romance Inc. official site',
  'related.fr.official.body': 'For details on the services and how to make a request, please visit the official site.',
  'related.fr.official.url': 'family-romance.com',
  'related.fr.lastUpdated': 'Last updated: July 5, 2026',

  'related.fr.gallery.workOffice': 'Family Romance staff meeting in the company office',
  'related.fr.gallery.philosophyBonds': 'An image representing the human connection Family Romance values',
  'related.fr.gallery.svcFamily': 'An image representing the family stand-in service Family Romance provides',

  // ===== Yuichi Ishii Official Site /related/ishii-yuichi =====
  'related.ishii.hero.home': 'Home',
  'related.ishii.hero.parent': 'Related Organizations',
  'related.ishii.hero.current': 'Yuichi Ishii Official Site',
  'related.ishii.hero.title': 'Yuichi Ishii Official Site',
  'related.ishii.hero.titleEn': 'YUICHI ISHII OFFICIAL SITE',
  'related.ishii.hero.lead':
    'The official site introducing the work of Yuichi Ishii, the Third Todori (head) of The All Japan Butler Association, as an actor and entrepreneur.',
  'related.ishii.hero.imgAlt': 'Portrait of Yuichi Ishii',

  'related.ishii.about.label': 'ABOUT',
  'related.ishii.about.title': 'What is the Yuichi Ishii official site?',
  'related.ishii.about.subtitleEn': 'What is the Yuichi Ishii official site?',
  'related.ishii.about.para1':
    'The Yuichi Ishii official site brings together the profile of Yuichi Ishii — Third Todori (head) of The All Japan Butler Association and, as Butler Bell, a media voice for butler culture — as an actor and entrepreneur. \n\nBorn in 1981, he has run Family Romance Inc. \n\nas founder and CEO, offering family stand-in services since 2004.',
  'related.ishii.about.para1Link': 'getstage.com',
  'related.ishii.about.para2':
    'In 2019, he starred as himself in German director Werner Herzog’s film "Family Romance, LLC," which screened in the Directors’ Fortnight section of the 72nd Cannes Film Festival. \n\nThat same year, he was invited to speak at a Harvard University conference, where he received the Glass Award.',
  'related.ishii.about.para2Link': 'See his work as an actor',
  'related.ishii.about.para3': 'He is the author of "The Human Rental Shop" (Tetsujinsha, 2019).',

  'related.ishii.points.label': 'HIGHLIGHTS',
  'related.ishii.points.title': 'Four highlights of Yuichi Ishii’s career',
  'related.ishii.points.subtitleEn': 'What Yuichi Ishii does',
  'related.ishii.points.1.title': 'Work as an actor',
  'related.ishii.points.1.desc':
    'Starred as himself in the 2019 film "Family Romance, LLC" (dir. Werner Herzog), which screened in the Directors’ Fortnight section of the 72nd Cannes Film Festival.',
  'related.ishii.points.2.title': 'Work as an entrepreneur',
  'related.ishii.points.2.desc':
    'Founder and CEO of Family Romance Inc. Since 2004, he has expanded family stand-in services, spreading the concept of "family stand-ins," which did not exist in Japan, throughout society.',
  'related.ishii.points.3.title': 'Lecture at Harvard University',
  'related.ishii.points.3.desc':
    'In 2019, he was invited to speak at the Harvard Global Health & Leadership Conference on the social significance of family stand-in services, and received the Glass Award.',
  'related.ishii.points.4.title': 'Published work',
  'related.ishii.points.4.desc':
    'Author of "The Human Rental Shop" (Tetsujinsha, 2019), reflecting on the connections between people he has witnessed through stand-in service work.',

  'related.ishii.role.label': 'RELATIONSHIP WITH TJBA',
  'related.ishii.role.title': 'Connection with the Academy',
  'related.ishii.role.subtitleEn': 'Connection with the academy',
  'related.ishii.role.para1':
    'Yuichi Ishii is the Third Todori (head) of The All Japan Butler Association, the operating body of Japan Butler Academy, and shares butler culture as Butler Bell through YouTube and other media. \n\nDetails of his work as an actor and entrepreneur can be found on his official site.',
  'related.ishii.role.para1Link': 'getstage.com',
  'related.ishii.role.para2':
    'Ishii’s career, covered by media in Japan and abroad, resonates with Japan Butler Academy’s aim of positioning the butler profession as a professional field evaluated against clear standards.',
  'related.ishii.role.para2Link': 'See his full profile',

  'related.ishii.official.title': 'Yuichi Ishii official site',
  'related.ishii.official.body': 'For details of his work as an actor and entrepreneur, please visit the official site.',
  'related.ishii.official.url': 'getstage.com',
  'related.ishii.lastUpdated': 'Last updated: July 5, 2026',

  'related.ishii.gallery.harvard': 'Yuichi Ishii speaking about family stand-in services at his Harvard University lecture',
  'related.ishii.gallery.frLlc01': 'Still of Yuichi Ishii starring as himself in the film "Family Romance, LLC"',
  'related.ishii.gallery.frLlc02': 'Still from a filming scene of "Family Romance, LLC"',
};

export default related;
